export class ExternalValidationResultAlert {
  constructor(
    public isError: boolean,  // エラーの場合true.(trueが1つでもあると登録できません.)
    public kind: string,  // 警告一覧に表示される警告の種類.
    public description: string,  // 警告一覧に表示される警告の詳細.
    public id?: number,  // 問題があるオブジェクトのID.
    public name?: string,  // 問題があるオブジェクトの名称.
  ) {}
}
